import globals from './Globals';
import loader from './Loader';
import RenderContainer from './RenderContainer';
import TextFrame from './TextFrame';
import NextPrevTextButton from './NextPrevTextButton';
import Stage from './Stage';

class Page extends RenderContainer {
  constructor(index, ebookModel) {
    super();
    // TODO revert to index, no modulo
    this.index = index;

    /* the first page is the menu page, 
       where the image is half the width of a regular page and
       the extra space is taken up by the menu buttons
    */
   this.isMenuPage = this.index === 0;

    // in seconds
    this.noNarrationPageDuration = 10;

    // Sets up bitmap to load
    this.imageName = this.isMenuPage
      ? ebookModel.cover.name
      : ebookModel.pages[this.index - 1].image.name;

    this.offset = index * globals.width;
    this.bitmap = null;

    this.pageHasAudio = this.isMenuPage || ebookModel.pageHasNarration(this.index);

    if (this.pageHasAudio) {
      this.narrationName = this.isMenuPage
        ? ebookModel.title.name
        : ebookModel.pages[this.index - 1].content.narration.name;

      this.narration = null;
      this.narrationInstance = createjs.WebAudioPlugin.playEmptySound();
      loader.addItem(this, this.narrationName);
    }
    loader.addItem(this, this.imageName);

    this.x = this.offset;
    this.y = 0;
    
    this.textFrame = new TextFrame(ebookModel.getTextOfPage(index), index);
    this.addChildAt(this.textFrame, 0);

    
    this.width = globals.width;
    this.height = globals.height;

    this.setBounds(0, 0, this.width, this.height);

    if (this.index !== 0) {
      console.log(this.textFrame.locations)
      if (this.textFrame.locations.length === 1) {
        console.log('text is only one line long');
      } else {
        console.log('text is longer than one line');
      }

      this.nextTextButton = new NextPrevTextButton('next', `NextTextBtnPressPage${this.index}`);
      this.addChildAt(this.nextTextButton, 0);
      
      this.previousTextButton = new NextPrevTextButton('prev', `PreviousTextBtnPressPage${this.index}`);
      this.addChildAt(this.previousTextButton, 0);

      this.nextTextButton.visible = true;
      this.previousTextButton.visible = false;

      Stage.on(`hideNextTextButtonPage${this.index}`, this.hideNextTextButton.bind(this))
      Stage.on(`showNextTextButtonPage${this.index}`, this.showNextTextButton.bind(this))

      Stage.on(`hidePrevTextButtonPage${this.index}`, this.hidePrevTextButton.bind(this))
      Stage.on(`showPrevTextButtonPage${this.index}`, this.showPrevTextButton.bind(this))

      Stage.on('ShowTextButtons', this.moveDownNextPrevTextBtns, this);
      Stage.on('HideTextButtons', this.moveUpNextPrevTextBtns, this);
    }
  }

  // Returns the sound duration in seconds
  getSoundDuration() {
    return this.pageHasAudio ? this.narration.duration : this.noNarrationPageDuration;
  }

  hideNextTextButton() {
    this.nextTextButton.visible = false
  }
  showNextTextButton() {
    this.nextTextButton.visible = true
  }

  hidePrevTextButton() {
    this.previousTextButton.visible = false
  }
  showPrevTextButton() {
    this.previousTextButton.visible = true
  }

  moveDownNextPrevTextBtns() {
    this.showNextTextButton()
    this.showPrevTextButton()
  }

  moveUpNextPrevTextBtns() {
    this.hideNextTextButton()
    this.hidePrevTextButton()
  }

  homeText() {
    this.textFrame.homeText();
  }

  loaded() {
    if (this.pageHasAudio) {
      this.narration = loader.getItem(this.narrationName);
    }

    const tag = loader.getItem(this.imageName);
    this.bitmap = new createjs.Bitmap(tag);
    RenderContainer.clipImageSizeToSize(this.bitmap, {
      width: this.width,
      height: this.height
    });
    RenderContainer.centerOnSelfSelf(this.bitmap, {
      x: this.width,
      y: this.height
    });
    this.addChildAt(this.bitmap, 0);

    // Is menu page
    if (this.isMenuPage) {
      this.bitmap.x += globals.width * 0.2;
    }

    this.render.stream = false;
    this.render.once = true;
  }
}

export { Page as default };
